import {FormControl, FormGroup, Validators} from "@angular/forms";
import {isCloneValueValidator} from "../../../../shared/form-elements/validators/is-clone-value";
import {emailInUseValidator} from "../../../../shared/form-elements/validators/email-in-use";
import {authStore} from "../../../../core/service/auth/auth.store";
import {inject} from "@angular/core";

export type CompanyHandlingForm = {
    id: FormControl<number>,
    name: FormControl<string>,
    phoneNumber: FormControl<string>,
    addressFirst: FormControl<string>,
    addressSecond: FormControl<string>,
    postalCode: FormControl<string>,
    city: FormControl<string>,
    region: FormControl<string>,
    country: FormControl<string>,
    businessNumber: FormControl<string>
}

export type UserHandlingForm = {
    id: FormControl<number>,
    email: FormControl<string>,
    password?: FormControl<string>,
    passwordConfirmation?: FormControl<string>,
    phoneNumber: FormControl<string>,
    roles?: FormControl<string[]>,
    company?: FormGroup<CompanyHandlingForm>|FormControl<number>,
    approveUserConditions?: FormControl<boolean>
}

export function newUserHandlingForm(user: any = undefined, action: 'create'|'edit'|'register' = 'create'): FormGroup<UserHandlingForm> {

    const hasAdminAuth = inject(authStore).hasAuthority('ROLE_EMPLOYEE_ADMIN');

    const userForm = new FormGroup<UserHandlingForm>({
        id: new FormControl(user?.id ?? null),
        email: new FormControl(user?.email || '', { validators: [Validators.required, Validators.email], asyncValidators: [emailInUseValidator("/api/loginUser/email", user?.email)] }),
        phoneNumber: new FormControl(user?.phoneNumber ?? ''),
        roles: new FormControl<string[]>(user?.roles ?? [])
    });

    if(action !== 'edit'){
        userForm.addControl('password', new FormControl('', { validators: [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*:{}()\[\]])[A-Za-z\d!@#$%^&*:{}()\[\]]{8,}$/)]}));
        userForm.addControl('passwordConfirmation', new FormControl('', { validators: [Validators.required]}));
        userForm.controls.passwordConfirmation.addValidators(isCloneValueValidator(userForm.controls.password));
        userForm.controls.passwordConfirmation.updateValueAndValidity({emitEvent: false});
    }

    if(action === 'register'){
        userForm.addControl('approveUserConditions', new FormControl(false, { validators: [Validators.requiredTrue]}));
    }

    if(hasAdminAuth()){
        userForm.addControl('roles', new FormControl<string[]>(user?.roles ?? []));
    }

    if(user?.company){
        userForm.addControl('company', new FormControl(user?.company));
    }

    return userForm;
}

export function newCompanyHandlingForm(): FormGroup<CompanyHandlingForm> {
    return new FormGroup({
        id: new FormControl(),
        name: new FormControl('', { validators: [Validators.required]}),
        phoneNumber: new FormControl(''),
        addressFirst: new FormControl(''),
        addressSecond: new FormControl(''),
        postalCode: new FormControl(''),
        city: new FormControl(''),
        region: new FormControl(''),
        country: new FormControl(''),
        businessNumber: new FormControl('',{validators: [Validators.required]})
    })
}